<template lang="pug">
    #navigator
        v-layout(column ma-3)
            .folder
                template(v-if="calendarsIsEmpty")
                    .text-center.font-weight-light.py-4.subtitle-2 Calendar Not Found
                template(v-else)
                    v-list(nav dense subheader shaped max-height="600" class="folder__item")
                        template(v-if="true")
                            v-subheader.font-weight-bold Pin
                            v-divider.mb-1
                            template(v-if="pinItems.length")
                                template(v-for="f in pinItems")
                                    v-list-item(:key="f.id"
                                        :input-value="currentCalendarId === f.id"
                                        @click="onSelectCalendar(f)")
                                        v-list-item-content
                                            v-list-item-title {{f.title}}
                                        v-btn(small icon @click.stop="onClickDownload(f)" v-if="false")
                                            v-icon(color="grey") mdi-cloud-download-outline
                                        v-btn(small icon @click.stop="onClickPin(f)")
                                            v-icon(color="warning") mdi-pin
                                        v-btn(small icon @click.stop="onClickSubscribe(f)")
                                            v-icon(:color="f.subscribe ? 'warning':'grey'") {{f.subscribe ? 'mdi-bell-ring' : 'mdi-bell-outline'}}
                            template(v-else)
                                v-list-item
                                    v-list-item-content
                                        v-list-item-title -- None --
                        template(v-if="true")
                            v-subheader.font-weight-bold Starred
                            v-divider.mb-1
                            template(v-if="favoriteItems.length")
                                template(v-for="f in favoriteItems")
                                    v-list-item(:key="f.id"
                                        :input-value="currentCalendarId === f.id"
                                        @click="onSelectCalendar(f)")
                                        v-list-item-content
                                            v-list-item-title {{f.title}}
                                        v-btn(small icon @click.stop="onClickFavorite(f)")
                                            v-icon(color="warning") mdi-star
                                        v-btn(small icon @click.stop="onClickDownload(f)" v-if="false")
                                            v-icon(color="grey") mdi-cloud-download-outline
                                        v-btn(small icon @click.stop="onClickPin(f)")
                                            v-icon(color="grey") mdi-pin-outline
                                        v-btn(small icon @click.stop="onClickSubscribe(f)")
                                            v-icon(:color="f.subscribe ? 'warning':'grey'") {{f.subscribe ? 'mdi-bell-ring' : 'mdi-bell-outline'}}
                            template(v-else)
                                v-list-item
                                    v-list-item-content
                                        v-list-item-title -- None --
                        template(v-if="true")
                            v-subheader.font-weight-medium All
                            v-divider.mb-1
                            template(v-if="allItems.length")
                                template(v-for="f in allItems")
                                    v-list-item(:key="f.id"
                                        :input-value="currentCalendarId === f.id"
                                        @click="onSelectCalendar(f)")
                                        v-list-item-content
                                            v-list-item-title {{f.title}}
                                        v-btn(small icon @click.stop="onClickFavorite(f)")
                                            v-icon(color="grey") mdi-star-outline
                                        v-btn(small icon @click.stop="onClickDownload(f)" v-if="false")
                                            v-icon(color="grey") mdi-cloud-download-outline
                                        v-btn(small icon @click.stop="onClickPin(f)")
                                            v-icon(color="grey") mdi-pin-outline
                                        v-btn(small icon @click.stop="onClickSubscribe(f)")
                                            v-icon(:color="f.subscribe ? 'warning':'grey'") {{f.subscribe ? 'mdi-bell-ring' : 'mdi-bell-outline'}}
                            template(v-else)
                                v-list-item
                                    v-list-item-content
                                        v-list-item-title -- None --
</template>

<script>
import isEmpty from "lodash/isEmpty";

export default {
  name: "Navigator",
  props: {
    favoriteItems: {
      type: Array,
      default: () => []
    },
    allItems: {
      type: Array,
      default: () => []
    },
    pinItems: {
      type: Array,
      default: () => []
    },
    currentCalendar: {
      type: Object,
      default: () => ({})
    },
    currentCalendarId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    calendarsIsEmpty() {
      return (
        this.pinItems.length === 0 &&
        this.favoriteItems.length === 0 &&
        this.allItems.length === 0
      );
    },
    calendarSelected() {
      return !!this.currentCalendarId && !isEmpty(this.currentCalendar);
    },
    pickerViewIsYear() {
      return (
        this.calendarSelected && this.currentCalendar.calendar_type === "Year"
      );
    }
  },
  methods: {
    onSelectCalendar(folder) {
      this.$emit("calendar", folder);
    },
    onClickFavorite(folder) {
      this.$emit("fav", folder);
    },
    onClickPin(folder) {
      this.$emit("pin", folder);
    },
    onClickDownload(folder) {
      this.$emit("download", folder);
    },
    onClickSubscribe(folder) {
      this.$emit("subscribe", folder);
    }
  }
};
</script>

<style scoped lang="scss">
.folder {
  border-style: solid;
  border-color: grey;
  border-width: 2px;

  .folder__item {
    overflow-y: auto;
  }
}
</style>
